import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XIcon, ExternalLinkIcon } from "@heroicons/react/outline";
import { useContextualHelp } from "hooks/Help";
import { removeDuplicateSlashes } from "Utils";

export default function HelpPortal() {
    const helpHook = useContextualHelp();

    return (
        <Transition.Root show={helpHook.open} as={Fragment}>
            <Dialog
                as="div"
                className="fixed inset-0 z-50 overflow-hidden"
                onClose={helpHook.setOpen}
            >
                <div className="absolute inset-0 overflow-hidden">
                    <Dialog.Overlay className="absolute inset-0" />

                    <div className="fixed inset-y-0 right-0 flex max-w-full pl-10">
                        <Transition.Child
                            as={Fragment}
                            enter="transform transition ease-in-out duration-500 sm:duration-700"
                            enterFrom="translate-x-full"
                            enterTo="translate-x-0"
                            leave="transform transition ease-in-out duration-500 sm:duration-700"
                            leaveFrom="translate-x-0"
                            leaveTo="translate-x-full"
                        >
                            <div className="w-screen max-w-md">
                                <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                                    <div className="px-4 sm:px-6">
                                        <div className="flex items-start justify-between">
                                            <Dialog.Title className="text-lg font-medium text-gray-900">
                                                Help
                                            </Dialog.Title>
                                            <div className="ml-3 flex h-7 items-center space-x-4">
                                                <button
                                                    type="button"
                                                    className="focus:outline-none rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                                                    onClick={() => {
                                                        helpHook.setOpen(false);
                                                        window.open(
                                                            removeDuplicateSlashes(
                                                                "https://docs.getsnworks.com/ceo3/" +
                                                                    helpHook.helpPath
                                                            ),
                                                            "_blank"
                                                        );
                                                    }}
                                                >
                                                    <span className="sr-only">
                                                        Open in new window
                                                    </span>
                                                    <ExternalLinkIcon
                                                        className="h-6 w-6"
                                                        aria-hidden="true"
                                                    />
                                                </button>
                                                <button
                                                    type="button"
                                                    className="focus:outline-none rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                                                    onClick={() =>
                                                        helpHook.setOpen(false)
                                                    }
                                                >
                                                    <span className="sr-only">
                                                        Close panel
                                                    </span>
                                                    <XIcon
                                                        className="h-6 w-6"
                                                        aria-hidden="true"
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="relative mt-6 flex-1">
                                        <div className="absolute inset-0">
                                            <iframe
                                                title="Help Viewer"
                                                src={
                                                    "https://docs.getsnworks.com/ceo3" +
                                                    (helpHook.helpPath
                                                        ? helpHook.helpPath
                                                        : "")
                                                }
                                                className="h-full w-full"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
